<template>
  <td
    v-for="(cell, index) in filteredCells"
    :key="cell.key"
    class="sf-table-row-collapsible-item__cell tw-transition-all"
    :class="styles.body"
  >
    <div
      :data-testid="`sf-column-${index}`"
      class="tw-flex tw-items-center tw-gap-2"
    >
      <slot name="cell-display" :cell="cell" :index="index">
        {{ cell.value }}
      </slot>
    </div>
  </td>
</template>

<script setup lang="ts" generic="TR extends GroupedTableRow">
import type { GroupedTableRow } from './types'

import { useFilteredCells } from './use-filtered-cells'
import { useTableStyles } from './use-cell-styles'
import type { TableVariants } from './constants'
import { tableVariants } from './constants'

interface Props {
  ignoredColumns?: string[]
  rowData: TR
  variant?: TableVariants
}

const {
  rowData,
  ignoredColumns = ['id', 'groupBy'],
  variant = tableVariants.DEFAULT,
} = defineProps<Props>()

const { filteredCells } = useFilteredCells<TR>(rowData, ignoredColumns)
const { styles } = useTableStyles(variant)
</script>
<style lang="scss" scoped>
.sf-table-row-collapsible-item {
  &__cell:first-of-type {
    padding-left: 64px;
  }
}
</style>
